import { Picture } from '~components/Image';
import { STATIC_ADDRESS } from '~constant/env';

import { RankedInterviewReviewItem } from '../ChartContents/helper';
import { getEmojiImagePath } from './helper';
import * as S from './style';

interface Props {
  item: RankedInterviewReviewItem;
  isEmpty?: boolean;
}

interface EmojiProps {
  questionName: string;
}

export default function BarChart({ item, isEmpty }: Props) {
  if (isEmpty) {
    return (
      <S.BarChart>
        <S.LabelChartEmpty>
          <Emoji questionName={item.content} />
          {item.content}
        </S.LabelChartEmpty>
        <S.CountChartEmpty>{item.count}</S.CountChartEmpty>
      </S.BarChart>
    );
  }

  return (
    <S.BarChart>
      {item.count === 0 ? (
        <>
          <S.LabelChartZeroCount>
            <Emoji questionName={item.content} />
            {item.content}
          </S.LabelChartZeroCount>
          <S.BarValueIndicatorZeroCount role='img' rank={item.rank} />
          <S.CountChart>{item.count}</S.CountChart>
        </>
      ) : (
        <>
          <S.LabelChart>
            <Emoji questionName={item.content} />
            {item.content}
          </S.LabelChart>
          <S.BarValueIndicator role='img' rank={item.rank} />
          <S.CountChart>{item.count}</S.CountChart>
        </>
      )}
    </S.BarChart>
  );
}

function Emoji({ questionName }: EmojiProps) {
  const imageName = getEmojiImagePath(questionName);

  return (
    <S.EmojiWrapper>
      <Picture
        src={`${STATIC_ADDRESS}/images/${imageName}.png`}
        resolution2xSrc={`${STATIC_ADDRESS}/images/${imageName}@2x.png`}
        width={16}
        height={17}
      />
    </S.EmojiWrapper>
  );
}
